// ======================================================================
// File Name       : email
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/email';

export function doReceiveUserSearchResult(startPosition, recordNum, userList) {
  return {
    type: ActionTypes.EMAIL_RECEIVE_USER_SEARCH_RESULT,
    startPosition,
    recordNum,
    userList,
  };
}

export function doReceiveAllUserSearchResult(startPosition, recordNum, userList, userAttributeSearchText) {
  return {
    type: ActionTypes.EMAIL_RECEIVE_ALL_USER_SEARCH_RESULT,
    startPosition,
    recordNum,
    userList,
    userAttributeSearchText,
  };
}

export function checkAllUser() {
  return {
    type: ActionTypes.EMAIL_CHECK_ALL_USER,
  };
}

export function doReceiveGroupStructureList(structureList) {
  return {
    type: ActionTypes.EMAIL_RECEIVE_STRUCTURE_LIST,
    structureList,
  };
}

export function addRemoveUser(userSecernId) {
  return {
    type: ActionTypes.EMAIL_ADD_REMOVE_USER,
    userSecernId,
  };
}

export function addRemoveAllUser() {
  return {
    type: ActionTypes.EMAIL_ADD_REMOVE_ALL_USER,
  };
}

export function addSelectedUser() {
  return {
    type: ActionTypes.EMAIL_ADD_SELECTED_USER,
  };
}

export function removeUser(userSecernId) {
  return {
    type: ActionTypes.EMAIL_REMOVE_USER,
    userSecernId,
  };
}

export function removeAllUser() {
  return {
    type: ActionTypes.EMAIL_REMOVE_ALL_USER,
  };
}

export function doReceiveSearchCondition(payload) {
  return {
    type: ActionTypes.EMAIL_RECEIVE_SEARCH_CONDITION,
    payload,
  };
}

export function addGroup(group) {
  return {
    type: ActionTypes.EMAIL_ADD_GROUP,
    group,
  };
}

export function removeGroup(index) {
  return {
    type: ActionTypes.EMAIL_DEL_GROUP,
    index,
  };
}

export function removeSelectedUser() {
  return {
    type: ActionTypes.EMAIL_REMOVE_SELECTED_USER,
  };
}

export function resetInitData() {
  return {
    type: ActionTypes.EMAIL_RESET_INIT_DATA,
  };
}

export function resetSearchUserData() {
  return {
    type: ActionTypes.EMAIL_RESET_SEARCH_USER_DATA,
  };
}

export function resetSearchUserCondition() {
  return {
    type: ActionTypes.EMAIL_RESET_SEARCH_USER_CONDITION,
  };
}

export function getEmailList(resData) {
  return {
    type: ActionTypes.GET_EMAIL_LIST,
    resData,
  };
}

export function getEmailDetail(emailInfo) {
  return {
    type: ActionTypes.GET_EMAIL_DETAIL,
    emailInfo,
  };
}

export function getReservedEmailList(resData) {
  return {
    type: ActionTypes.GET_RESERVED_EMAIL_LIST,
    resData,
  };
}

export function getReservedEmailDetail(emailSenderIdAuto) {
  return {
    type: ActionTypes.GET_RESERVED_EMAIL_DETAIL,
    emailSenderIdAuto,
  };
}

export function getReservedEmailDetailForEdit(resData) {
  return {
    type: ActionTypes.GET_RESERVED_EMAIL_EDIT,
    resData,
  };
}

export function allUserReceived(emailList, userList, recordNum) {
  return {
    type: ActionTypes.ALL_USER_RECEIVED_BY_EMAIL,
    emailList,
    userList,
    recordNum,
  };
}

export function allUserAttributeReceived(data) {
  return {
    type: ActionTypes.ALL_USER_ATTRIBUTE_RECEIVED,
    data,
  };
}

export function allUserGroupRelationReceived(data) {
  return {
    type: ActionTypes.ALL_USER_GROUP_RELATION_RECEIVED,
    data,
  };
}

export function allGroupRelationReceived(data) {
  return {
    type: ActionTypes.ALL_GROUP_RELATION_RECEIVED,
    data,
  };
}

export function allUserListReceived(data) {
  return {
    type: ActionTypes.ALL_USER_LIST_RECEIVED,
    data,
  };
}

export function addUsersToListByEmail(userListToAdd) {
  return {
    type: ActionTypes.ADD_USER_TO_LIST_BY_EMAIL,
    userListToAdd,
  };
}

export function saveReceiver(receiverSaveKey) {
  return {
    type: ActionTypes.SAVE_RECEIVER,
    receiverSaveKey,
  };
}

export function saveEmailReceiverSaveKey(data) {
  return {
    type: ActionTypes.SAVE_EMAIL_RECEIVER_SAVE_KEY,
    data,
  };
}

export function backupInitState() {
  return {
    type: ActionTypes.BACKUP_INIT_STATE,
  };
}

export function restoreInitState() {
  return {
    type: ActionTypes.RESTORE_INIT_STATE,
  };
}

export function receiveUsersFromCourseHistory(userList) {
  return {
    type: ActionTypes.RECEIVE_USERS_FROM_COURSE_HISTORY,
    userList,
  };
}

export function insertTemplateData(isUsedTemplate, courseDetail) {
  return {
    type: ActionTypes.INSERT_TEMPLATE_DATA,
    isUsedTemplate,
    courseDetail,
  };
}
